<script>
  import type { IPageData } from "../../../core/types";
  import Schedule from "../../blocks/schedule/Schedule.svelte";
  import TwoColumns from "../TwoColumns.svelte";

  interface ISchedulePage extends IPageData {
    title: string;
  }

  export let data: ISchedulePage;
</script>

<TwoColumns>
  <div class="g-centered">
    <div class="title">{data?.title}</div>
  </div>

  <slot />
</TwoColumns>

<div class="schedule-page g-centered">
  <Schedule />
</div>

<style lang="scss">
  .schedule-page {
    margin-bottom: 50px;
  }

  .title {
    @include h1;
    margin-bottom: 50px;
  }
</style>
